import { ReactNode } from 'react';

interface StarBackgroundProps {
  children: ReactNode;
}

export function StarBackground({ children }: StarBackgroundProps) {
  return (
    <div className="relative min-h-screen">
      <div className="fixed inset-0 -z-10 bg-paper dark:bg-space-950">
        <div className="absolute inset-0 dark:bg-space-gradient">
          <div className="stars absolute inset-0 opacity-0 dark:opacity-100"></div>
          <div className="nebula absolute inset-0 opacity-0 dark:opacity-100"></div>
        </div>
      </div>
      {children}
    </div>
  );
}
